<template>
    <ModalDefaultInner
        v-model="showDefaultModal"
        :modal-data="infoModalData"
        @cta="action"
        @cancel="cancelAction"
        size="2xl"
    >
        <template #icon>
            <CardIcon type="success">
                <CodeIcon />
            </CardIcon>
        </template>

        <CardCodeHeight :heightLimit="160" class="mt-5">{{ modalData.code }} </CardCodeHeight>
    </ModalDefaultInner>
</template>

<script>
import { CardIcon, CardCodeHeight } from "@easy/ui/cards";
import { CodeIcon } from "@easy/ui/icons";
import { ModalDefaultInner } from "@easy/ui/modals";

export default {
    components: {
        ModalDefaultInner,
        CardIcon,
        CodeIcon,
        CardCodeHeight,
    },
    data() {
        return {
            showDefaultModal: false,
            infoModalData: {
                title: this.modalData.title,
                description: this.modalData.desc,
                ctaLabel: this.modalData.actionBtn,
                cancelLabel: this.modalData.cancelBtn,
            },
        };
    },
    props: {
        modalData: Object,
    },
    methods: {
        action() {
            this.modalData.callback();
            this.$emit("close");
        },
        action2() {
            this.modalData.callback2();
            this.$emit("close");
        },
        cancelAction() {
            if (this.modalData.cancelCallback) {
                this.modalData.cancelCallback();
            }
            this.$emit("close");
        },
    },
};
</script>
